// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageSelect_container__MeLlG","select":"LanguageSelect_select__Ab71x","input":"LanguageSelect_input__2FFgj"};